// extracted by mini-css-extract-plugin
export var heroTextContainer = "HeroCard-module--hero-text-container--2eIVk";